import Actions from "../../actions";
import * as requestFromServer from "./serviceProviderCustomersApis";

// get all service provider customers -> api
export const getServiceProviderCustomersAction = (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.getServiceProviderCustomers(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_CUSTOMERS_LIST, {serviceProviderCustomers:response}));
      return response;
    }
};


// update customer status -> update customer status api
export const updateServiceProviderCustomerStatusAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.updateServiceProviderCustomerStatus(dataToBeSent);
  if (response) {
    return response;
  }
};


export const searchCustomersAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true)
  const response = await requestFromServer.searchCustomers(dataToBeSent);
  if (response) {
    setLoading(false)
    return response;
  }
  else {
    setLoading(false)
    return null
  }
}


export const getCustomerDetailsAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true)
  const response = await requestFromServer.getCustomerDetails(dataToBeSent);
  dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_CUSTOMER_DETAILS, {selectedServiceProviderCustomerDetails:response}));
  if (response) {
    setLoading(false)
    return response;
  }
  else {
    setLoading(false)
    return null
  }
}